import { useState } from 'react';
import Tooltip from '@material-ui/core/Tooltip';
import { IconButton } from '@material-ui/core';
import ViewModuleIcon from '@material-ui/icons/ViewModule';
import ViewAgendaIcon from '@material-ui/icons/ViewAgenda';
import PictureInPictureIcon from '@material-ui/icons/PictureInPicture';
import ViewCarouselIcon from '@material-ui/icons/ViewCarousel';
import VerticalPresentationIcon from './VerticalPresentationIcon';
import SingleSpeakerAndSlidesIcon from './SingleSpeakerAndSlidesIcon';
import { checkDivsInMainPanel ,canControlBroadcast,isPrimaryHost,hasActiveControl,isCoHost} from 'utils';
import { toast } from 'react-hot-toast';
export default function LayoutPanel({ isScreenSharing, setSelectedLayouts }) {
  const [selectedLayout, setSelectedLayout] = useState(null);

  const handleLayoutClick = (layout) => {
    if (canControlBroadcast() && sessionStorage.getItem('broadcastId') && hasActiveControl()) {
      let mainPanelDivCheck = checkDivsInMainPanel();
      if (
        (layout === 'pip' || layout === 'custom') &&
        mainPanelDivCheck.otDivCount > 1
      ) {
        console.log(
          'No API call needed for PIP or CUSTOM layout with otdivCount > 1'
        );
        toast(
          'Can’t add more than one speaker to the selected layout. Remove additional speakers from live stage, then re-select layout.'
        );
        return;
      }
      setSelectedLayout(layout);
      setSelectedLayouts(layout);
      fetch(
        `${
          process.env.REACT_APP_API_URL
        }/v2/livemeeting/changeLayout/${sessionStorage.getItem(
          'broadcastId'
        )}/${layout}`,
        {
          method: 'POST',
        }
      )
        .then((res) => {
          return res.json();
        })
        .then((res) => {
          console.log(res);
        })
        .catch(handleCallback);
    } else if(canControlBroadcast() && !sessionStorage.getItem('broadcastId')){
      toast(`You can change layout once you Go Live`);
    }else if(canControlBroadcast() && sessionStorage.getItem('broadcastId') && !hasActiveControl() && isCoHost()){
      toast(`You need to request control from the host first`);
    }else if(canControlBroadcast() && sessionStorage.getItem('broadcastId') && !hasActiveControl() && isPrimaryHost()){
      toast(`Take controls back to change layout`);
    }
    else{
      toast(`You don't have permission to select layout`);
    }
  };

  function handleCallback(error) {
    if (error) {
      console.log('error: ' + error.message);
    } else {
      console.log('callback success');
    }
  }

  const iconStyle = {
    margin: 10,
    padding: 10,
    width: 40,
    height: 40,
    backgroundColor: '#32353A',
    cursor: 'pointer',
    borderRadius: '0%',
  };

  const iconSelectedStyle = {
    border: '2px solid #fff',
  };
  console.log(isScreenSharing);
  return (
    <div>
      <div
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          justifyContent: 'center',
          position: 'relative',
        }}
      >
        <Tooltip title='Panel'>
          <IconButton
            style={{
              ...iconStyle,
              ...(selectedLayout === 'bestFit' && iconSelectedStyle),
            }}
            onClick={() => handleLayoutClick('bestFit')}
          >
            <ViewModuleIcon style={{ color: 'white', fontSize: '1.5rem' }} />
          </IconButton>
        </Tooltip>
        <Tooltip title='Vertical Speakers with Screenshare'>
          <IconButton
            style={{
              ...iconStyle,
              ...(selectedLayout === 'verticalPresentation' &&
                iconSelectedStyle),
            }}
            onClick={() => handleLayoutClick('verticalPresentation')}
          >
            <VerticalPresentationIcon
              style={{ color: 'white', fontSize: '1.5rem' }}
            />
          </IconButton>
        </Tooltip>
        <Tooltip title='Picture In Picture'>
          <IconButton
            style={{
              ...iconStyle,
              ...(selectedLayout === 'pip' && iconSelectedStyle),
            }}
            onClick={() => handleLayoutClick('pip')}
          >
            <PictureInPictureIcon
              style={{ color: 'white', fontSize: '1.5rem' }}
            />
          </IconButton>
        </Tooltip>
        <Tooltip title='Single Speaker and Screenshare'>
          <IconButton
            style={{
              ...iconStyle,
              ...(selectedLayout === 'custom' && iconSelectedStyle),
            }}
            onClick={() => handleLayoutClick('custom')}
          >
            <SingleSpeakerAndSlidesIcon
              style={{ color: 'white', fontSize: '1.5rem' }}
            />
          </IconButton>
        </Tooltip>
      </div>
    </div>
  );
}
